// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"bbdee045","252":"e72f7e99","304":"25d61957","453":"b84bc319","809":"e5ebac62"}[chunkId] + ".chunk.js";
};